export enum PARRequestType {
  ActAmendment = 3,
  ActPreparation = 4,
}
